namespace TabAurous.OMS {
    export interface TaxDetailsForm {
        TaxId: Serenity.IntegerEditor;
        GroupId: Serenity.DecimalEditor;
        SelectedtaxId: Serenity.DecimalEditor;
    }

    export class TaxDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.TaxDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TaxDetailsForm.init)  {
                TaxDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(TaxDetailsForm, [
                    'TaxId', w0,
                    'GroupId', w1,
                    'SelectedtaxId', w1
                ]);
            }
        }
    }
}
